import { Tooltip } from '@calendly/ui/components/tooltip';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { NavigationIconContainer, NavigationLabel, navigationLabelCaptionMinimizedCss } from '../elements';
import { useLeftNavigationState } from '../hooks';
import { NavigationItem } from '../navigation_item';
const navigationItemWrapperCss = "nunh645";
const NavigationItemWrapper = forwardRef((props, ref) => <span ref={ref} {...props} className={classNames(navigationItemWrapperCss, props.className)} />);
const NavigationItemBody = ({
  config,
  isMinimized,
  ...props
}) => <NavigationItem data-calendly-label={config.dataCalendlyLabel} to={config.to} activePaths={config.activePaths} {...props}>
    <NavigationIconContainer>
      {config.icon}
    </NavigationIconContainer>
    <NavigationLabel>
      {isMinimized ? <span className={navigationLabelCaptionMinimizedCss}>{config.caption}</span> : <>
            {config.caption}
            {config.postTextIcon}
          </>}
    </NavigationLabel>
    {config.inlineObject}
  </NavigationItem>;
export const DefaultNavigationItem = ({
  config,
  ...props
}) => {
  const leftNavigationState = useLeftNavigationState();
  const isNavMinimized = leftNavigationState === 'phone-collapsed' || leftNavigationState === 'minimized';
  return <Tooltip text={isNavMinimized ? config.caption : null} placement="right">
      <NavigationItemWrapper>
        <NavigationItemBody config={config} isMinimized={isNavMinimized} {...props} />
        {config.spotlight}
      </NavigationItemWrapper>
    </Tooltip>;
};

require("./default-navigation-item.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./default-navigation-item.js");